import { Component,OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../config';
import { MdDialog,MdDialogRef } from '@angular/material';
import { HttpService } from '../../shared/services/http.service'
import { LayoutService } from '../../layout/layout.service'
import { SessionHandler } from '../../shared/services/session-handler.service';
import { CommonService } from '../../shared/services/common.service';
import { Subject }    from 'rxjs/Subject';
import { dialogComponent } from '../../dialog/dialog.component';
import { TranslateService } from 'ng2-translate';

@Component({
    selector: 'add-new-contact',
    template: require('./addNewContact.component.html'),
    styles: [require('./addNewContact.component.scss'),require('../../style.scss')],
    providers: [HttpService,SessionHandler]
})
export class addNewContactComponent implements OnInit {
    newContactName:any;
    newContactEmail:any;
    newContactPhone:any;
    nameContactValid:boolean = false;
    emailContactValid:boolean = false;
    phoneContactValid:boolean = false;
    selectedContactName:any = null;
    selectedContactEmail:any = null;
    selectedContactPhone:any = null;
    new_contact :any;
    isIcb:boolean = false;
    dialogRef;
    tradeId:any;
    saving = false;
    fromFoc: boolean = false;
    MAX_PHONE:any = 15;
    MAX_EMAIL:any = 50;
    MAX_NAME:any = 40;

    constructor(private router: Router,private http:HttpService,private translate: TranslateService,private commonService:CommonService,
        private sessionHandler:SessionHandler,private dialog: MdDialog) {}
    ngOnInit():void {}

    public closeDialog(){
        this.dialog.closeAll();
    }

    public newContactValidation(field,evt) {
        if(field == 'name') {
            if (/^[a-z0-9_ -]+$/i.test(evt) == false)  {
                this.nameContactValid = false;
            } else {
                this.nameContactValid = true;
            }
        }
        if(field == 'phone') {
            if (/^[0-9+\s]+$/i.test(evt) == false)  {
                this.phoneContactValid = false;
            } else {
                this.phoneContactValid = true;
            }
        }
        if(field == 'email'){
            if (/^\w+([.-]\w+)*@\w+([.-]\w+)*(\.\w{2,})+$/.test(evt) == false)
            {
                this.emailContactValid = false;
            } else {
                this.emailContactValid = true;
            }
        }
    }

    public saveNewContact() {
        if (this.saving) return;
        if (this.nameContactValid && this.emailContactValid && this.phoneContactValid) {
            this.saving = true;
            this.closeDialog();
            this.http.showLoader();
            this.new_contact = {};
            this.new_contact.contactName = this.selectedContactName = this.newContactName;
            this.new_contact.contactPhone = this.selectedContactPhone = this.newContactPhone;
            this.new_contact.contactEmail = this.selectedContactEmail = this.newContactEmail;
            this.new_contact.tradePartnerId = this.tradeId;
            this.new_contact.fromFoc = this.fromFoc;
            this.http.postRequest(this.new_contact, 'userOperationsApi/v1/addContact').subscribe(
                res => {
                    this.saving = false;
                    this.http.onEnd();
                    if (res['statusCode'] == 200) {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = this.translate.instant('contact_added_success');
                        this.dialogRef.afterClosed().subscribe(result => {
                            if (result) {
                                this.commonService.changeContactData();
                            }
                            this.dialogRef = null;
                        });
                    } else {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = res['status'];
                    }
                },
                err => {
                    this.saving = false;
                    this.http.onEnd();
                    if (err && err.status != 0) {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                }
            );
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/trade/details/addNewContact.component.ts